export default __webpack_public_path__ + "static/media/attractor-logo-stroke.1d6468d6.svg";